import React, { useCallback, useEffect, useState } from 'react';

import { announceRaffle } from 'api/raffle/raffle_announce';
import { setIsAnnounce } from 'store/features/raffleDetailsSlice';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { errMsg } from '../PageElement/ErrorMessage';
import { successMsg } from '../PageElement/SuccessMessage';
import { Raffle } from 'api/raffle/raffle_detail';
import { Champion, FileEdit02, MessageNotifySquare } from 'lib/lucky-x-icons-2';
import AddPrpject from '../Project/Add';
import { useToggle } from 'ahooks';

const OwnerOperate = () => {
  const [openProject, { toggle, set }] = useToggle(false);
  const dispatch = useAppDispatch();
  const { raffleInfo, isOwner, isAnnounce } = useAppSelector(
    (state) => state.raffleDetails
  );

  const [raffle, setRaffle] = useState<Raffle>();
  const [isRaffleOwner, setIsRaffleOwner] = useState(false);
  const [raffleIsAnnounce, setRaffleIsAnnounce] = useState(false);

  useEffect(() => {
    setRaffle(raffleInfo);
    setIsRaffleOwner(isOwner);
    setRaffleIsAnnounce(isAnnounce);
  }, [isAnnounce, isOwner, raffleInfo]);

  const handleAnnounce = useCallback(async () => {
    const res = await announceRaffle(raffle?.vanity_url as string);
    if (res?.code === 0) {
      dispatch(setIsAnnounce(true));
      successMsg('Raffle announced successfully');
    } else {
      errMsg(res?.msg);
    }
  }, [dispatch, raffle?.vanity_url]);

  const announceBtn = useCallback(() => {
    if (!raffle?.is_dc_new_raffle_announced && !raffleIsAnnounce) {
      return (
        <div
          className="active:buttonShadow group relative flex h-10 cursor-pointer items-center justify-center gap-2 rounded-[100px] bg-primary-500 hover:bg-primary-600 md:w-1/3 xl:w-full 2xl:w-1/3"
          onClick={handleAnnounce}
        >
          <div>Announce</div>
          <MessageNotifySquare size={20} />
          <div
            className="absolute -left-[180px] bottom-4  z-20 hidden min-w-[180px] rounded-lg border-2 border-neutral-700 bg-neutral-800 px-2 py-3 text-center text-sm font-normal  text-neutral-200 lg:group-hover:block"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            Announce to Discord
          </div>
        </div>
      );
    }
  }, [handleAnnounce, raffleIsAnnounce, raffle?.is_dc_new_raffle_announced]);

  if (!isRaffleOwner) {
    return null;
  }

  return (
    <div className="mt-8 grid grid-cols-1 gap-4 text-sm font-medium text-neutral-100 md:flex lg:mb-8 lg:mt-0 xl:grid xl:grid-cols-1 2xl:flex">
      {announceBtn()}
      <div className="grid grid-cols-2 gap-4 md:w-2/3 xl:w-full xl:grid-cols-2 2xl:w-2/3">
        <div
          className="active:buttonShadow flex h-10 cursor-pointer items-center justify-center gap-2 rounded-[100px] bg-primary-500 hover:bg-primary-600"
          onClick={() => {
            open(
              `/builder/create_raffle?campaign_id=${raffle?.campaign?.id}&raffle_id=${raffle?.id}`
            );
          }}
        >
          <div>Edit raffle</div>
          <FileEdit02 size={20} />
        </div>
        <div
          className="active:buttonShadow flex h-10 cursor-pointer items-center justify-center gap-2 rounded-[100px] bg-primary-500 hover:bg-primary-600"
          onClick={() => {
            open(
              `/builder/raffledetail?campaign_id=${raffle?.campaign?.id}&raffle_id=${raffle?.id}`
            );
          }}
        >
          <div>Entries</div>
          <Champion size={20} />
        </div>
      </div>
      <AddPrpject
        open={openProject}
        onClose={() => {
          set(false);
        }}
        data={raffleInfo.project}
      />
    </div>
  );
};

export default OwnerOperate;
